export const ICONS = {
	COLLECTION_FILL_ICON: `${process.env.PUBLIC_URL}/icons/collection-tab.svg`,
	DESIGN_UNFILL_ICON: `${process.env.PUBLIC_URL}/icons/design-tab.svg`,
	COLLECTION_UNFILL_ICON: `${process.env.PUBLIC_URL}/icons/collection-line.svg`,
	DESIGN_FILL_ICON: `${process.env.PUBLIC_URL}/icons/design-fill.svg`
};
